import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    window.dispatchEvent(
      new CustomEvent("academy:frontend-error", {
        detail: { message: error.message, stack: info.componentStack },
      }),
    );
  }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main
        role="alert"
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          padding: 24,
          background: "#060716",
          color: "#f7f8ff",
          font: "16px/1.5 Inter,system-ui,sans-serif",
        }}
      >
        <section style={{ maxWidth: 560 }}>
          <p style={{ color: "#22d3ee", fontWeight: 800 }}>WORKSPACE_ERROR</p>
          <h1>This workspace could not continue.</h1>
          <p>The interface reached an unexpected state. Your saved mock records remain available.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              minHeight: 44,
              padding: "0 16px",
              border: 0,
              borderRadius: 10,
              background: "#8b5cf6",
              color: "white",
              font: "inherit",
              fontWeight: 800,
            }}
          >
            Reload workspace
          </button>
        </section>
      </main>
    );
  }
}
